export default (state, param) => {
  state.fields = param
}



// WEBPACK FOOTER //
// ./src/store/modules/order_custom_form/mutations/setOrderCustomFormSort.js